"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _logo = require("@/api/logo/logo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getProvince } from "@/api/admin/user/user";
var _default = exports.default = {
  data: function data() {
    return {
      provinceList: [],
      logoInfo: {
        title: "",
        expertAuthentication: 0,
        adminLogo: "",
        webLogo: "",
        footer: "",
        loginLogo: "",
        provinceId: this.$route.query.id
      },
      imageUrl: ""
    };
  },
  methods: {
    successUpLoad: function successUpLoad(e) {
      this.logoInfo.webLogo = e.ossOriUrl;
    },
    successUpLoad2: function successUpLoad2(e) {
      this.logoInfo.loginLogo = e.ossOriUrl;
    },
    successUpLoad3: function successUpLoad3(e) {
      this.logoInfo.adminLogo = e.ossOriUrl;
    },
    successUpLoad4: function successUpLoad4(e) {
      this.logoInfo.newsBanner = e.ossOriUrl;
    },
    successUpLoad5: function successUpLoad5(e) {
      this.logoInfo.onlieCourseBanner = e.ossOriUrl;
    },
    successUpLoad6: function successUpLoad6(e) {
      this.logoInfo.videoCouresBanner = e.ossOriUrl;
    },
    successUpLoad7: function successUpLoad7(e) {
      this.logoInfo.competitionBanner = e.ossOriUrl;
    },
    successUpLoad8: function successUpLoad8(e) {
      this.logoInfo.resourceBanner = e.ossOriUrl;
    },
    submit: function submit() {
      var _this = this;
      (0, _logo.addProvLogo)(this.logoInfo).then(function (res) {
        if (res.code === 2000) {
          _this.$message.success("操作成功。");
          _this.$router.push("/webSet/logoSet");
        }
      });
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/webSet/logoSet");
    }
  },
  created: function created() {
    // this.getProvinceList();
  },
  components: {
    FileImg: _index.default
  }
};